// TODO update this to import from commons
// import { gql } from '@reverbdotcom/commons/src/gql';
// eslint-disable-next-line no-restricted-imports
import { gql } from '@apollo/client';
import React from 'react';
import { ShopCardFields } from '@reverbdotcom/commons/src/gql/graphql';
import { ShopBadges } from '@reverbdotcom/commons/src/components/shop_badges';
import { RCCard, RCImage, RCStarRating } from '@reverbdotcom/cadence/components';
import ShopSvg from '@reverbdotcom/cadence/images/brand/my-shop-orange.svg';

interface IProps {
  shop: ShopCardFields.Fragment;
}

export const COMPONENT_NAME = 'ShopCard';

function ShopCard({ shop }: IProps) {
  const avatarUrl = shop.user.avatar?.source;

  return (
    <div
      className="shop-card"
      itemType="https://schema.org/Store"
    >
      <RCCard
        key={shop._id}
        bgColorToken="rc-color-background-page"
        fullHeight
      >
        <div className="shop-card__content">
          <RCImage
            src={avatarUrl || ShopSvg}
            alt=""
            overlay="offwhiteWithHover"
            borderRadius="md"
            imageBox="fullWidth"
          />
          <div className="shop-card__title">
            {shop.name}
          </div>
          <div className="shop-card__location">
            {shop.address.displayLocation}
          </div>
          <RCStarRating
            rating={shop.user.feedbackSummary.rollingRatingPercentage / 100}
            count={shop.user.feedbackSummary.receivedCount}
          />
          <div className="pt-2">
            <ShopBadges
              preferredSeller={shop.preferredSeller}
              quickShipper={shop.quickShipper}
              hideLabels
              smallBadges
            />
          </div>
        </div>
      </RCCard>
    </div>

  );
}

export const ShopCardFragment = gql`
  fragment ShopCardFields on Shop {
    _id
    name
    preferredSeller
    quickShipper
    address {
      _id
      displayLocation
    }
    user {
      _id
      avatar {
        _id
        source
      }
      feedbackSummary {
        rollingRatingPercentage
        receivedCount
      }
    }
  }
`;

export default ShopCard;
